/**
 * Constants
 * Artifcats for the events module
 *
 * @todo Maybe these will be called in via Contentful eventually?
 */

export const eventTypes = [
  {
    name: 'All Events',
    type: 'all'
  },
  {
    name: 'Hosted',
    include: ['Hosted'],
    type: 'hosted'
  },
  {
    name: 'Third Party',
    include: ['Third Party'],
    type: 'third party'
  },
  {
    name: 'Webinars',
    include: ['Webinars'],
    type: 'webinars'
  }
]
// RWR-4874, Change the Current Events label to Upcoming Events - Fixed
export const sortTypes = [
  {
    name: 'Upcoming Events',
    type: 'upcoming'
  },
  {
    name: 'Past Events',
    type: 'past'
  }
]

export const filSecRegTypes = [
  {
    name: 'Sector',
    type: 'sector'
  },
  {
    name: 'Region',
    type: 'region'
  }
]
